import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
    meta: {
      name: 'nav.home',
      breadcrumbs: () => {
        return [
        ]
      }
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      name: 'nav.about_us',
      breadcrumbs: () => {
        return [
         
          {
            label: 'nav.about_us'
          }
        ]
      }
    }
  },
  {
    path: '/news',
    component: () => import(/* webpackChunkName: "news-index" */ '../views/NewsIndexView.vue'),
    children: [
     
    ],
    meta: {
      name: 'nav.news',
      breadcrumbs: () => {
        return [
         
          {
            label: 'nav.news'
          }
        ]
      }
    }
  },
  {
    path: '/news/:name',
    component: () => import(/* webpackChunkName: "news-detail" */ '../views/NewsView.vue'),
    meta: {
      name: 'nav.news',
      breadcrumbs: (route) => {
        return [
          {
            label: 'nav.news',
            route: '/news'
          },
          {
            label: 'news.'+route.params.name+'.title'
          }
        ]
      }
    }
  },
  {
    path: '/contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue'),
    meta: {
      name: 'nav.contact_us',
      breadcrumbs: (route) => {
        return [
          {
            label: 'nav.contact_us',
          }
        ]
      }
    }
  },
  {
    path: '/products',
    component: () => import(/* webpackChunkName: "products-index" */ '../views/ProductIndexView.vue'),
    meta: {
      name: 'nav.products',
      breadcrumbs: (route) => {
        return [
          {
            label: 'nav.products',
          }
        ]
      }
    }
  },
  {
    path: '/products/:category',
    component: () => import(/* webpackChunkName: "products-category" */ '../views/ProductIndexView.vue'),
    meta: {
      name: 'nav.products',
      breadcrumbs: (route) => {
        return [
          {
            label: 'nav.products',
            route: '/products',
          },
          {
            label: 'products_categories.'+route.params.category
          }
        ]
      }
    }
  },
  {
    path: '/products/:id(\\d+)',
    component: () => import(/* webpackChunkName: "product-detail" */ '../views/ProductView.vue'),
    meta: {
      name: 'nav.products',
      breadcrumbs: (route) => {
        return [
          {
            label: 'nav.products',
            route: '/products',
          },
          {
            label: 'products.'+route.params.id + '.name'
          }
        ]
      }
    }
  },
  {
    path: '/services',
    component: () => import(/* webpackChunkName: "services" */ '../views/ServiceView.vue'),
    meta: {
      name: 'nav.services',
      breadcrumbs: (route) => {
        return [
          {
            label: 'nav.services'
          }
        ]
      }
    }
  },
  {
    path: '/health-education/:id',
    component: () => import(/* webpackChunkName: "health-education" */ '../views/HealthEducationView.vue'),
    meta: {
      toTop: true,
      name: 'nav.health-education',
      breadcrumbs: (route) => {
        return [
          {
            label: 'nav.health-education'
          }
        ]
      }
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.toTop) {
      return { top: 0, behavior: 'smooth' };
    }
    return savedPosition;
  }
})

export default router
